import moment from 'moment-timezone';

export const dayDifferenceWithTZ = (tz) => {
  const datePattern = 'MM/DD/YYYY';
  const localTimezoneDay = moment().format(datePattern);
  const PSTTimezoneDay = moment().tz(tz).format(datePattern);
  return moment(PSTTimezoneDay, datePattern).diff(moment(localTimezoneDay, datePattern), 'days');
};

export const getOrConvertToPst = (date = undefined) => moment(date).tz('America/Los_Angeles');
